<template>
  <div id="app-live-stream-info" :class="isLiveInfoOpen ? 'expanded' : ''">
    <div v-if="isStateReady" class="stream-info">
      <div ref="streamScroll" class="stream-info__inner">
        <div ref="channelSlot" class="stream-info__inner__channel">
          <div class="channel-card">
            <div class="channel-card__inner">
              <div v-if="channelOne.shows.current" class="channel-card__inner__image">
                <picture>
                  <img
                    :src="
                      channelOne.shows.current.image_path
                        ? channelOne.shows.current.image_path
                        : mrLogo
                    "
                  />
                </picture>
              </div>
              <div class="channel-card__inner__info">
                <div class="current-episode">
                  <div class="current-date">
                    {{ formatDateToTime(channelOne.shows.current.starts) }} -
                    {{ formatDateToTime(channelOne.shows.current.ends) }} on Stegi Radio 1
                  </div>
                  <router-link
                    v-if="channelOne.shows.current.url"
                    :to="{ path: formatUrl(channelOne.shows.current.url) }"
                    class="current-name-link"
                  >
                    <div class="current-name">
                      {{ playingNowTitle1 }}
                    </div>
                  </router-link>
                  <div v-else class="current-name">
                    {{ playingNowTitle1 }}
                  </div>
                  <div class="current-description" v-html="channelOne.shows.current.description" />
                </div>
                <div v-if="playingNextTitle1" class="next-episode">
                  <div class="next-episode__inner">
                    <div class="next-episode__inner__date">
                      NEXT EPISODE -
                      {{
                        formatDateToTime(
                          channelOne.shows.next[
                            channelOne.shows.next[0].name.includes('Movement Ident') ? 1 : 0
                          ].starts
                        )
                      }}
                      -
                      {{
                        formatDateToTime(
                          channelOne.shows.next[
                            channelOne.shows.next[0].name.includes('Movement Ident') ? 1 : 0
                          ].ends
                        )
                      }}
                    </div>
                    <div class="next-episode__inner__name">
                      {{ playingNextTitle1 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button type="button"
                  class="scroll-down"
                  @click="scrollToChannelTwo"
          >
            scroll for more
          </button>
        </div>
        <div class="stream-info__inner__channel">
          <div class="channel-card">
            <div class="channel-card__inner">
              <div v-if="channelTwo.shows.current" class="channel-card__inner__image">
                <picture>
                  <img
                    :src="
                      channelTwo.shows.current.image_path
                        ? channelTwo.shows.current.image_path
                        : mrLogo
                    "
                  />
                </picture>
              </div>
              <div class="channel-card__inner__info">
                <div class="current-episode">
                  <div class="current-date">
                    {{ formatDateToTime(channelTwo.shows.current.starts) }} -
                    {{ formatDateToTime(channelTwo.shows.current.ends) }} on Stegi Radio 2
                  </div>
                  <router-link
                    v-if="channelTwo.shows.current.url"
                    :to="{ path: formatUrl(channelTwo.shows.current.url) }"
                    class="current-name-link"
                  >
                    <div class="current-name">
                      {{ playingNowTitle2 }}
                    </div>
                  </router-link>
                  <div v-else class="current-name">
                    {{ playingNowTitle2 }}
                  </div>
                  <div class="current-description" v-html="channelTwo.shows.current.description" />
                </div>
                <div v-if="playingNextTitle2" class="next-episode">
                  <div class="next-episode__inner">
                    <div class="next-episode__inner__date">
                      NEXT EPISODE -
                      {{
                        formatDateToTime(
                          channelTwo.shows.next[
                            channelTwo.shows.next[0].name.includes('Movement Ident') ? 1 : 0
                          ].starts
                        )
                      }}
                      -
                      {{
                        formatDateToTime(
                          channelTwo.shows.next[
                            channelTwo.shows.next[0].name.includes('Movement Ident') ? 1 : 0
                          ].ends
                        )
                      }}
                    </div>
                    <div class="next-episode__inner__name">
                      {{ playingNextTitle2 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment';
import mrLogo from '@/assets/logos/stegi-radio-logo-black.svg';
export default {
  name: 'AppLiveStreamInfo',
  data: () => ({
    mrLogo: mrLogo,
    isMobile: false
  }),
  computed: {
    ...mapState({
      isLiveInfoOpen: state => state.liveStreamInfoState,
      channelOne: state => state.liveStreamInfoDataOne,
      channelTwo: state => state.liveStreamInfoDataTwo,
      isStateReady(state) {
        return (
          Object.keys(state.liveStreamInfoDataOne).length != 0 &&
          Object.keys(state.liveStreamInfoDataTwo).length != 0
        );
      },
      playingNowTitle1(state) {
        if (state.liveStreamInfoDataOne.shows.current) {
          const currentName = state.liveStreamInfoDataOne.shows.current.name;
          const nextName = state.liveStreamInfoDataOne.shows.next[0].name;
          const playingNowName = currentName.includes('Movement Ident') ? nextName : currentName;
          return this.removeWeirdCharacters(playingNowName);
        } else {
          return 'Movement Radio #1';
        }
      },
      playingNextTitle1(state) {
        if (state.liveStreamInfoDataOne.shows.next.length >= 2) {
          const currentName = state.liveStreamInfoDataOne.shows.next[0].name;
          const nextName = state.liveStreamInfoDataOne.shows.next[1].name;
          const playingNowName = currentName.includes('Movement Ident') ? nextName : currentName;
          return this.removeWeirdCharacters(playingNowName);
        } else {
          return;
        }
      },
      playingNowTitle2(state) {
        if (state.liveStreamInfoDataTwo.shows.current) {
          const currentName = state.liveStreamInfoDataTwo.shows.current.name;
          const nextName = state.liveStreamInfoDataTwo.shows.next[0].name;
          const playingNowName = currentName.includes('Movement Ident') ? nextName : currentName;
          return this.removeWeirdCharacters(playingNowName);
        } else {
          return 'Movement Radio #2';
        }
      },
      playingNextTitle2(state) {
        if (state.liveStreamInfoDataTwo.shows.next.length >= 2) {
          const currentName = state.liveStreamInfoDataTwo.shows.next[0].name;
          const nextName = state.liveStreamInfoDataTwo.shows.next[1].name;
          const playingNowName = currentName.includes('Movement Ident') ? nextName : currentName;
          return this.removeWeirdCharacters(playingNowName);
        } else {
          return;
        }
      }
    })
  },
  watch: {
    '$route.name'() {
      this.$store.commit('setLiveStreamInfoState', false);
    },
    isLiveInfoOpen(value) {
      if (value && this.isMobile) {
        this.$root.$el.parentElement.classList.add('no-scroll');
        this.scrollToTop();
      } else {
        this.$root.$el.parentElement.classList.remove('no-scroll');
      }
    }
  },
  mounted() {
    this.checkDeviceViewPort();
  },
  methods: {
    removeWeirdCharacters(value) {
      if (value.includes('&#039;')) {
        value = value.replace(/&#039;/g, "'");
      }
      if (value.includes('&amp;')) {
        value = value.replace(/&amp;/g, '&');
      }
      return value;
    },
    checkDeviceViewPort() {
      let mql = window.matchMedia('(max-width: 768px)');
      if (mql.matches) this.isMobile = true;
      else this.isMobile = false;
    },
    formatDateToTime(date) {
      return moment(date).format('HH:mm');
    },
    formatUrl(url) {
      const path = new URL(url);
      return path.pathname;
    },
    scrollToTop() {
      this.$refs.streamScroll.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    scrollToChannelTwo() {
      const channelHeight = this.$refs.channelSlot.getBoundingClientRect().height;
      this.$refs.streamScroll.scrollTo({
        top: channelHeight,
        left: 0,
        behavior: 'smooth'
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_app-live-streaming-info.scss';
</style>
